import React from 'react';
import { Paper, styled, ToggleButton, ToggleButtonGroup, toggleButtonGroupClasses } from '@mui/material';

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(() => ({
  [`& .${toggleButtonGroupClasses.grouped}`]: {
    margin: 0,
    border: 0,
    borderRadius: 50,
    minWidth: "50px",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
  },
  padding: "4px",
  gap: "4px",
  height: "25px",
}));

const toggleButtonStyle = {
  fontSize: "12px",
  fontWeight: "bold",
  textTransform: "none",
  transition: "all 0.25s ease-in-out",
  "&.Mui-selected": {
    color: "#fff",
    fontWeight: "normal",
    "&:hover": { backgroundColor: "#ff8000" },
  },
};

const ShowHideToggle = ({ value }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        display: "flex",
        border: "none",
        flexWrap: "wrap",
        backgroundColor: "#ffffff",
        borderRadius: 50,
      }}
    >
      <StyledToggleButtonGroup
        size="small"
        value={value}
        exclusive
        aria-label="show-hide-toggle"
      >
        <ToggleButton
          size="small"
          value="Yes"
          aria-label="toggle-yes"
          sx={{
            ...toggleButtonStyle,
            "&.Mui-selected": {
              ...toggleButtonStyle["&.Mui-selected"],
              backgroundColor: "#ff8000",
            },
          }}
        >
          Yes
        </ToggleButton>

        <ToggleButton
          size="small"
          value="No"
          aria-label="toggle-no"
          sx={{
            ...toggleButtonStyle,
            "&.Mui-selected": {
              ...toggleButtonStyle["&.Mui-selected"],
              backgroundColor: "#ff8000",
            },
          }}
        >
          No
        </ToggleButton>
      </StyledToggleButtonGroup>
    </Paper>
  );
};

export default ShowHideToggle;
